<template>
  <w-icon-wrapper
    :height='23.998'
    :width='23.998'
    icon-name='work-sync-icon'
    view-box='0 0 23.998 23.998'
  >
    <g
      id='_36_Synchronisiert_Icon'
      data-name='36 Synchronisiert_Icon'
      transform='translate(-0.069 0.034)'
    >
      <path
        id='Pfad_55713'
        d='M23.9,9.966h-2.03a10.011,10.011,0,0,1-12.01,11.75,9.664,9.664,0,0,1-4.59-2.44h1.62a1,1,0,0,0,0-2h-5.2v5.2a1,1,0,1,0,2,0v-1.93a11.947,11.947,0,0,0,3.93,2.57,12.049,12.049,0,0,0,16.15-8.5A11.959,11.959,0,0,0,23.9,9.966Z'
        data-name='Pfad 55713'
        fill='currentColor'
      />
      <path
        id='Pfad_55714'
        d='M2.317,9.763a10.01,10.01,0,0,1,11.96-7.55,9.664,9.664,0,0,1,4.59,2.44h-1.62a1,1,0,0,0,0,2h5.2v-5.2a1,1,0,0,0-2,0v1.93a11.947,11.947,0,0,0-3.93-2.57,12.049,12.049,0,0,0-16.15,8.5,11.959,11.959,0,0,0-.13,4.65h2.03A9.92,9.92,0,0,1,2.317,9.763Z'
        data-name='Pfad 55714'
        fill='currentColor'
      />
      <path
        id='Pfad_55715'
        d='M14.861,8.751l-3.98,3.98L9.228,11.279a1,1,0,1,0-1.32,1.5l3.061,2.691,5.306-5.306a1,1,0,1,0-1.414-1.414Z'
        data-name='Pfad 55715'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconSync' };
</script>
